import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#2f2f2f',
      light: '#a2a2a2',
      contrastText: '#fffffe',
    },
    secondary: {
      main: '#f50057'
    },
    background: {
      default: '#ffffff',
    },
    text: {
      secondary: 'rgba(0,0,0,0.4)',
      disabled: 'rgba(0,0,0,0.2)',
    },
    typography: {
      h6: {
        fontSize: '1.1rem',
      },
    },
  },
  zIndex: {
    editedSection: 1600,
    authModal: 2000
  },
});
